import React from "react";
import { useTranslation } from "react-i18next";
import { ChevronLeft, ChevronRight, Plus } from "lucide-react";

interface AbsencesPageHeaderProps {
  monthLabel: string;
  onPreviousMonth: () => void;
  onNextMonth: () => void;
  onNew: () => void;
}

/** Title, intro, the "New absence" action and the month switcher. */
const AbsencesPageHeader: React.FC<AbsencesPageHeaderProps> = ({
  monthLabel,
  onPreviousMonth,
  onNextMonth,
  onNew,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="mb-1 text-2xl font-bold text-grey-20 dark:text-white">
            {t("absences.title", "Absences")}
          </h1>
          <p className="text-sm text-grey-40 dark:text-grey-80">
            {t("absences.pageIntro", "Who is away when — member vacations and closed days in one view.")}
          </p>
        </div>
        <button type="button" className="btn btn-primary" onClick={onNew}>
          <Plus size={16} />
          {t("absences.newAction", "New absence")}
        </button>
      </div>

      <div className="mb-3 flex items-center gap-2">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={onPreviousMonth}
          aria-label={t("absences.previousMonth", "Previous month")}
        >
          <ChevronLeft size={16} />
        </button>
        <span className="min-w-40 text-center font-semibold text-grey-20 dark:text-white">
          {monthLabel}
        </span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={onNextMonth}
          aria-label={t("absences.nextMonth", "Next month")}
        >
          <ChevronRight size={16} />
        </button>
      </div>
    </>
  );
};

export default AbsencesPageHeader;
